<div class="row">
  <div class="col-12">
    <div class="card w-100">
      <div class="card-body d-flex flex-column">
        <h5>
          {{ 'pages.transport.tracking-overview.widgets.saved-views.title' | translate }}
        </h5>
        @if (isLoading()) {
          <p-skeleton class="mb-2" />
          <p-skeleton width="10rem" class="mb-2" />
          <p-skeleton width="5rem" class="mb-2" />
          <p-skeleton height="2rem" class="mb-2" />
          <p-skeleton width="10rem" height="4rem" />
        }

        @if (isSuccess()) {
          <div class="save-view">
            <p-dataview
              [value]="data()"
              [paginator]="true"
              [showPageLinks]="true"
              [pageLinks]="3"
              [showFirstLastIcon]="false"
              [rows]="5"
              styleClass="border-0 save-view__dataview"
              [alwaysShowPaginator]="false"
              paginatorStyleClass="p--0"
            >
              <ng-template #list let-views>
                <table class="save-view__table">
                  <thead>
                    <tr class="sr-only d-none">
                      <th class="save-view__table__header">
                        {{ 'pages.transport.tracking-overview.widgets.saved-views.data-fields.hits' | translate }}
                      </th>
                      <th class="save-view__table__header">
                        {{ 'pages.transport.tracking-overview.widgets.saved-views.data-fields.name' | translate }}
                      </th>
                      <th class="save-view__table__header"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (view of views; track view.id) {
                      <tr transport-saved-view [savedView]="view"></tr>
                    }
                  </tbody>
                </table>
              </ng-template>
            </p-dataview>
          </div>
        }

        @if (isEmpty()) {
          <h6 class="empty-state__title">{{ 'pages.transport.tracking-overview.widgets.saved-views.empty-state.title' | translate }}</h6>
          <p class="empty-state__instructions">
            {{ 'pages.transport.tracking-overview.widgets.saved-views.empty-state.instructions' | translate }}
          </p>
          <ol>
            <li
              class="empty-state__instructions"
              [innerHTML]="'pages.transport.tracking-overview.widgets.saved-views.empty-state.instructions-line1' | translate"
            ></li>
            <li
              class="empty-state__instructions"
              [innerHTML]="'pages.transport.tracking-overview.widgets.saved-views.empty-state.instructions-line2' | translate"
            ></li>
            <li
              class="empty-state__instructions"
              [innerHTML]="'pages.transport.tracking-overview.widgets.saved-views.empty-state.instructions-line3' | translate"
            ></li>
            <li
              class="empty-state__instructions"
              [innerHTML]="'pages.transport.tracking-overview.widgets.saved-views.empty-state.instructions-line4' | translate"
            ></li>
          </ol>

          <div class="d-flex justify-content-end">
            <p-button
              icon="pi pi-external-link"
              iconPos="right"
              [label]="'pages.transport.tracking-overview.widgets.saved-views.empty-state.open-tracking-list' | translate"
              (onClick)="goToTrackingList()"
              styleClass="ml--4"
              variant="text"
            />
          </div>
        }

        @if (isOnError()) {
          <p-message severity="error">
            <span class="bold">
              {{ errorMessage().title }}
            </span>
            <span>
              {{ errorMessage().description }}
            </span>
          </p-message>
        }
      </div>
    </div>
  </div>
</div>
